/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function GetAllJobApplications() {
  const { data, setData } = useDataContext();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (data.getAllJobApplications && data.getAllJobApplications.length > 0) return;
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const response = await fetch(`${API_URL}/getAllJobApplications`, { method: "GET", redirect: "follow" });
        const result = await response.json();
        setData(prev => ({ ...prev, getAllJobApplications: result.data || [] }));
      } catch (error) {
        console.error("Error fetching job applications:", error);
        hasFetched.current = false;
      }
    };

    fetchData();
  }, []);

  return null;
}

export default GetAllJobApplications;